export default __webpack_public_path__ + "static/media/one.8885e136.jpeg";